export default __webpack_public_path__ + "static/media/Religion.e417d34d.svg";